import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ApplicationRoutes } from './routes/router';
import { GalleryProvider } from './context/GalleryContext';
import { UIProvider } from './context/UIContext';

// Provider order (architecture §5): HelmetProvider → GalleryProvider → UIProvider → RouterProvider.
function App() {
  return (
    <HelmetProvider>
      <GalleryProvider>
        <UIProvider>
          <RouterProvider router={ApplicationRoutes} future={{ v7_startTransition: true }} />
        </UIProvider>
      </GalleryProvider>
    </HelmetProvider>
  );
}

export default App;
